import * as moment from "moment";
export const toCamelCase = (string) => {
    if (string)
        return string.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    else
        return "";
};
export const formatRequestTypeText = (text) => {
    if (text && text.length) {
        let textArr = text.split("");
        textArr[0] = textArr[0].toUpperCase();
        textArr[3] = textArr[3].toUpperCase();
        textArr.splice(3, 0, "-");
        return textArr.join("");
    }
    return "";
};
export const convertEPochToDate = (epoch) => {
    if (!!epoch) {
        // const epocdate = moment(new Date(parseInt(epoch)).toLocaleString());
        const epochInt = Number(epoch);
        let epocdate;
        if (isNaN(epochInt)) {
            epocdate = moment(epoch);
        }
        else {
            epocdate = moment(epochInt);
        }
        //  const today = moment();
        // if (
        //   moment(epocdate.format("DD-MMM-YY")).isSame(today.format("DD-MMM-YY"))
        // ) {
        //   return epocdate.format("hh:mm:ss A");
        // } else {
        //   return epocdate.format("DD-MMM-YY hh:mm:ss A ");
        // }
        return epocdate.format("DD-MMM-YY hh:mm:ss A");
    }
    else
        return "";
};
export const timeDifference = (targetDate, format) => {
    // Parse the target date using moment
    const targetMoment = moment(targetDate, format);
    // Calculate the time difference in milliseconds
    const timeDiffInMilliseconds = moment().diff(targetMoment);
    // Convert milliseconds to minutes and hours
    const minutes = Math.floor(timeDiffInMilliseconds / (1000 * 60));
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    if (days !== 0) {
        return `${days} days ${hours % 24} hours ${minutes % (24 * 60)} minutes ago`;
    }
    else if (hours !== 0) {
        return `${hours} hours ${minutes % 60} minutes ago`;
    }
    else {
        return `${minutes} minutes ago`;
    }
};
export const getLatestTime = (momentTimes, format) => {
    const latestTime = moment.max(momentTimes);
    return latestTime.format("HH:mm:ss") === "Invalid date"
        ? ""
        : latestTime.format("HH:mm:ss");
};
